<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";

import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Permission Create",
      items: [
        {
          text: "Permission",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      permissionid: "",
      checked: true,
      errors: null,
      form: {
        permission_name: "",
        permisssion_tag: "",
        permisssion_type: "",
        permisssion_category: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      permission_name: {
        required,
      },
      permisssion_tag: {
        required,
      },
      permisssion_type: {
        required,
      },
      permisssion_category: {
        required,
      },
    },
  },
  created() {
    this.permissionid = this.$route.params.id;
  },
  mounted() {
    this.getPermissionDetail();
  },
  methods: {
    async getPermissionDetail() {
      try {
        axios
          .post("/api/permission_show/" + this.permissionid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            console.log(response);
            if (response.status == 200) {
              var data = response.data.data;
              this.form.permission_name = data.name;
              this.form.permisssion_tag = data.tag;
              this.form.permisssion_type = data.type;
              this.form.permisssion_category = data.category;
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/permission_update", {
          id: this.permissionid,
          name: this.form.permission_name,
          tag: this.form.permisssion_tag,
          type: this.form.permisssion_type,
          category: this.form.permisssion_category,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.status == 200) {
            var data = response.data;
            this.flashMessage.show({
              time: 5000,
              status: "success",
              title: "Message",
              message: response.data.message,
            });
            this.$router.push("/permission/all_permission");
          } else {
            this.flashMessage.show({
              time: 5000,
              status: "error",
              title: "Error",
              message: "Problem in data save",
            });
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="permission_name">Permission Name</label>
                    <input
                      id="permission_name"
                      v-model="form.permission_name"
                      name="permission_name"
                      type="text"
                      class="form-control"
                      placeholder="Type permission name"
                      value="form.permission_name"
                      :class="{ 'is-invalid': submitted && $v.form.permission_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permission_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permission_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="permisssion_tag">Permission Tag</label>
                    <input
                      id="permisssion_tag"
                      v-model="form.permisssion_tag"
                      name="permisssion_tag"
                      type="text"
                      class="form-control"
                      placeholder="Type permission tag"
                      value="form.permisssion_tag"
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_tag.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permisssion_tag.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_tag.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="permisssion_type">Permission Type</label>
                    <select 
                      id="permisssion_type"
                      name="permisssion_type"
                      v-model="form.permisssion_type"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_type.$error }">
                      <option :selected="form.permisssion_type == 'admin'" value="Admin" >Admin</option>
                      <option :selected="form.permisssion_type == 'b2b'" value="B2B">B2B</option>
                      <option :selected="form.permisssion_type == 'b2c'" value="B2C">B2C</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.permisssion_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_type.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="permisssion_category">Permission Category</label>
                    <input
                      id="permisssion_category"
                      v-model="form.permisssion_category"
                      name="permisssion_category"
                      type="text"
                      class="form-control"
                      placeholder="Type permission category"
                      value="form.permisssion_category"
                      :class="{ 'is-invalid': submitted && $v.form.permisssion_category.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.permisssion_category.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permisssion_category.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Update Permission</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>